const stopVideo = (slide) => {
  const video = slide.querySelector('video');
  if (video) {
    video.pause();
    video.currentTime = 0;
  }
};

const playVideo = (slide) => {
  const video = slide.querySelector('video');
  if (video) {
    video.muted = true;
    video.play().catch(() => {});
  }
};

export const initHeroSlideshow = () => {
  const container = document.querySelector('.c-hero__slides');
  if (!container) {
    return;
  }

  const heroType = container.dataset.heroType || 'slideshow';
  const slides = Array.from(container.querySelectorAll('.c-hero__slide'));
  
  // Single video mode - play all visible video variants (desktop + mobile)
  if (heroType === 'video' || slides.length <= 1) {
    slides.forEach((slide) => playVideo(slide));
    return;
  }

  const interval = Number(container.dataset.interval) || 4000;
  let index = slides.findIndex((slide) => slide.classList.contains('is-active'));
  if (index < 0) {
    index = 0;
    slides[0].classList.add('is-active');
  }

  slides.forEach((slide, idx) => {
    if (idx !== index) {
      stopVideo(slide);
    }
  });
  playVideo(slides[index]);

  const isTouchDevice = 'ontouchstart' in window || (window.DocumentTouch && document instanceof DocumentTouch);
  let timer = null;
  const showSlide = (nextIndex) => {
    if (nextIndex === index) {
      return;
    }
    const current = slides[index];
    const next = slides[nextIndex];
    current.classList.remove('is-active');
    stopVideo(current);
    next.classList.add('is-active');
    playVideo(next);
    index = nextIndex;
  };

  const tick = () => {
    const nextIndex = (index + 1) % slides.length;
    showSlide(nextIndex);
  };

  const start = () => {
    if (timer) {
      return;
    }
    timer = window.setInterval(tick, interval);
  };

  const stop = () => {
    if (timer) {
      window.clearInterval(timer);
      timer = null;
    }
  };

  start();

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      stop();
    } else {
      start();
    }
  });

  // No mouse-based pan effect on desktop; keep slideshow simple
};
